
import { Competition } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';

export interface IUserCompetitionAttempts {
    competitionId: string;
    current: number;
    max: number;
}

export interface CurrentCompetitionSliceStates {
    competition: Competition | undefined;
    attemptsRefreshNonce: number;
    userAttempts: IUserCompetitionAttempts | null;
}

const InitialState: CurrentCompetitionSliceStates = {
    competition: undefined,
    attemptsRefreshNonce: 0,
    userAttempts: null,
}

export const CurrentCompetitionSlice = createSlice({
    name: 'currentCompetition',
    initialState: InitialState,
    reducers: {
        setCurrentCompetition: (state, action) => {
            const nextCompetition = action.payload;
            if (state.userAttempts && nextCompetition?.competitionId !== state.userAttempts.competitionId) {
                state.userAttempts = null;
            }
            state.competition = nextCompetition;
        },
        reset: (state, action) => {
            state = InitialState
        },
        refreshAttemptsCheck: (state, action: { payload: { increment: number; competitionId: string; max: number } }) => {
            const { increment, competitionId, max } = action.payload;
            state.attemptsRefreshNonce += 1;
            if (max < 1 || !competitionId) {
                return;
            }
            if (state.userAttempts?.competitionId === competitionId) {
                state.userAttempts.current += increment;
                state.userAttempts.max = max;
            } else {
                state.userAttempts = {
                    competitionId,
                    current: increment,
                    max,
                };
            }
        },
        setUserAttempts: (state, action: { payload: IUserCompetitionAttempts | null }) => {
            state.userAttempts = action.payload;
        },
    },
});

export default CurrentCompetitionSlice
export const CurrentCompetitionActions = CurrentCompetitionSlice.actions
export const CurrentCompetitionSelector = (store: { currentCompetition: CurrentCompetitionSliceStates }): CurrentCompetitionSliceStates => store.currentCompetition;

import { Competition } from '@brg/api';
import { createSlice } from '@reduxjs/toolkit';

export interface IUserCompetitionAttempts {
    competitionId: string;
    current: number;
    max: number;
}

export interface CurrentCompetitionSliceStates {
    competition: Competition | undefined;
    attemptsRefreshNonce: number;
    userAttempts: IUserCompetitionAttempts | null;
}

const InitialState: CurrentCompetitionSliceStates = {
    competition: undefined,
    attemptsRefreshNonce: 0,
    userAttempts: null,
}

export const CurrentCompetitionSlice = createSlice({
    name: 'currentCompetition',
    initialState: InitialState,
    reducers: {
        setCurrentCompetition: (state, action) => {
            const nextCompetition = action.payload;
            if (state.userAttempts && nextCompetition?.competitionId !== state.userAttempts.competitionId) {
                state.userAttempts = null;
            }
            state.competition = nextCompetition;
        },
        reset: (state, action) => {
            state = InitialState
        },
        refreshAttemptsCheck: (state, action: { payload: { increment: number; competitionId: string; max: number } }) => {
            const { increment, competitionId, max } = action.payload;
            state.attemptsRefreshNonce += 1;
            if (max < 1 || !competitionId) {
                return;
            }
            if (state.userAttempts?.competitionId === competitionId) {
                state.userAttempts.current += increment;
                state.userAttempts.max = max;
            } else {
                state.userAttempts = {
                    competitionId,
                    current: increment,
                    max,
                };
            }
        },
        setUserAttempts: (state, action: { payload: IUserCompetitionAttempts | null }) => {
            state.userAttempts = action.payload;
        },
    },
});

export default CurrentCompetitionSlice
export const CurrentCompetitionActions = CurrentCompetitionSlice.actions
export const CurrentCompetitionSelector = (store: { currentCompetition: CurrentCompetitionSliceStates }): CurrentCompetitionSliceStates => store.currentCompetition;
